import ISelection from '@core/models/betSlip/ISelection';
import OfferEvent from '@core/models/offer/OfferEvent';
import { RegistrationType } from '@superbet-group/product.analytics';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { IdentityProvider } from '@superbet-group/web.types';

export function logEventDetailsView(event: OfferEvent): void {
    let oddsHome = null;
    let oddsDraw = null;
    let oddsAway = null;

    const basicOddsCodes = ['10', '11', '12'];
    const odds = event.getOdds().filter((odd) => basicOddsCodes.includes(odd.code));

    if (odds.length === 3) {
        [oddsHome, oddsDraw, oddsAway] = odds;
    } else if (odds.length === 2) {
        [oddsHome, oddsAway] = odds;
    }

    AnalyticsSDK.getInstance()
        .log('Event_Details_View', {
            eventId: String(event.id),
            eventType: event.isOngoing() ? 'Live' : 'Not live',
            tournamentName: event.tournamentName,
            sport: event.sportName,
            sportId: String(event.sportId),
            team_home_name: event.team1Name,
            team_away_name: event.team2Name,
            scheduled: event.date.toISOString(),
            odds_home: String(oddsHome?.value || 'N/A'),
            odds_draw: String(oddsDraw?.value || 'N/A'),
            odds_away: String(oddsAway?.value || 'N/A'),
        });
}

export function logBetslipEventAddEvent(selection: ISelection) {
    AnalyticsSDK.getInstance().log('Betslip_Event_Add', {
        eventLabel: selection.event.fullName,
        eventName: selection.event.fullName,
        eventId: selection.event.id,
        eventType: selection.isOngoing() ? 'Live' : 'Not Live',
        oddValue: selection.odd?.value.toString() ?? '',
        pick: selection.odd?.name ?? '',
        tournamentName: selection.event.tournamentName,
        sport: selection.event.sportName,
        sportId: selection.event.sportId,
        team_home_name: selection.event.team1Name,
        team_away_name: selection.event.team2Name,
        scheduled: selection.event.matchTimestamp ? new Date(selection.event.matchTimestamp).toISOString() : '',
        odds_home: selection.event.odds?.[0]?.value,
        odds_draw: selection.event.odds?.[1]?.value,
        odds_away: selection.event.odds?.[2]?.value,
    });
}

export function logBetslipEventRemoveEvent(selection: ISelection) {
    AnalyticsSDK.getInstance().log('Betslip_Event_Remove', {
        eventLabel: 'Remove Multiple Events',
        eventName: selection.event.fullName,
        eventId: selection.event.id,
        eventType: selection.isOngoing() ? 'Live' : 'Not Live',
        oddValue: selection.odd?.value.toString() ?? '',
        pick: selection.odd?.name ?? '',
        tournamentName: selection.event.tournamentName,
        sport: selection.event.sportName,
        sportId: selection.event.sportId,
    });
}

// @TODO: migration-v2 will depricate createLanderRegistrationResultAnalyticsPayload
export function getPayloadRegistrationType(identityProvider: string): RegistrationType {
    switch (identityProvider) {
        case IdentityProvider.MojeId:
            return RegistrationType.REGISTRATION_TYPE_MOJEID;
        case IdentityProvider.ItsMe:
            return RegistrationType.REGISTRATION_TYPE_ITS_ME;
        default:
            return RegistrationType.REGISTRATION_TYPE_STANDARD;
    }
}
